import { Box, Typography } from '@mui/material'

/**
 * Label / value pairs for the drawers. `items` = [{ label, value, strong }];
 * a null value prints an em dash rather than an empty cell, so a missing figure
 * is visibly missing and never mistaken for a layout gap.
 */
export default function KeyValue({ items, columns = 2, dense = false }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: `repeat(${columns}, minmax(0, 1fr))` },
        columnGap: 2,
        rowGap: dense ? 0.75 : 1.25,
      }}
    >
      {(items || []).filter(Boolean).map((it) => (
        <Box key={it.label} sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#888', fontWeight: 600, lineHeight: 1.2 }}>
            {it.label}
          </Typography>
          <Typography
            component='div'
            sx={{
              fontSize: 12.5, color: '#1a1a2e', fontWeight: it.strong ? 700 : 500, mt: '2px',
              wordBreak: 'break-word', lineHeight: 1.4,
            }}
          >
            {it.value == null || it.value === '' ? '—' : it.value}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}

export function Section({ title, right, children, sx }) {
  return (
    <Box sx={{ border: '1px solid #e5e7eb', borderRadius: '10px', p: 2, width: '100%', ...sx }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 1.25 }}>
        <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#1a1a2e', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
          {title}
        </Typography>
        {right}
      </Box>
      {children}
    </Box>
  )
}
